let defaultLang = "en";
let currentLang = defaultLang;

let strings = {
    "Please wait": {
        "de": "Bitte warten"
    },
    "All pictures uploaded": {
        "de": "Alle Bilder hochgeladen"
    },
    "Uploading pictures": {
        "de": "Bilder werden hochgeladen"
    },
    "Last response time": {
        "de": "Letzte Antwortzeit"
    },
    "Battery level": {
        "de": "Batterieladung"
    },
    "Battery state": {
        "de": "Batteriestatus"
    },
    "Full": {
        "de": "Voll"
    },
    "Charging": {
        "de": "Lädt"
    },
    "Discharging": {
        "de": "Entlädt"
    },
    "Energy saving mode": {
        "de": "Energiesparmodus"
    },
    "Yes": {
        "de": "Ja"
    },
    "No": {
        "de": "Nein"
    },
    "Network type": {
        "de": "Netzwerktyp"
    },
    "Mobile": {
        "de": "Mobilfunk"
    },
    "WiFi": {
        "de": "WLAN"
    },
    "Ethernet": {
        "de": "Ethernet"
    },
    "Bluetooth": {
        "de": "Bluetooth"
    },
    "VPN": {
        "de": "VPN"
    },
    "Platform": {
        "de": "Plattform"
    },
    "Device": {
        "de": "Gerät"
    },
    "Camera enabled": {
        "de": "Kamera aktiviert"
    },
    "Microphone enabled": {
        "de": "Mikrofon aktiviert"
    },
    "Orientation": {
        "de": "Orientierung"
    },
    "Vertical": {
        "de": "Vertikal"
    },
    "Horizontal": {
        "de": "Horizontal"
    },
    "Volume": {
        "de": "Lautstärke"
    },
    "App version": {
        "de": "App Version"
    },
    "Call ended": {
        "de": "Anruf beendet"
    },
    "Call canceled": {
        "de": "Anruf abgebrochen"
    },
    "Enter message": {
        "de": "Nachricht eingeben"
    },
    "Send": {
        "de": "Senden"
    },
    "Take picture": {
        "de": "Bild erstellen"
    },
    "Stop": {
        "de": "Beenden"
    },
    "Image queue": {
        "de": "Bilder Warteschlange"
    },
    "Camera state": {
        "de": "Kamera Status"
    },
    "Unknown": {
        "de": "Unbekannt"
    },
    "Stream active": {
        "de": "Stream aktiv"
    },
    "Stopping stream": {
        "de": "Stoppe Stream"
    },
    "Stream stopped": {
        "de": "Stream gestoppt"
    },
    "Taking picture": {
        "de": "Bild wird erstellt"
    },
    "Starting stream": {
        "de": "Starte Stream"
    },
    "Permission for microphone was denied": {
        "de": "Berechtigung für Mikrofon wurde nicht erteilt"
    },
    "Audio output device": {
        "de": "Audio-Ausgabegerät"
    },
    "Audio input device": {
        "de": "Audio-Eingabegerät"
    },
    "Continue": {
        "de": "Weiter"
    },
    "Cancel": {
        "de": "Abbrechen"
    },
    "Restart camera": {
        "de": "Kamera neu starten"
    },
    "Connection quality (BO)": {
        "de": "Verbindungsqualität (BO)"
    },
    "Connection quality (Client)": {
        "de": "Verbindungsqualität (Client)"
    },
    "Error": {
        "de": "Fehler"
    },
    "Very bad": {
        "de": "Sehr schlecht"
    },
    "Bad": {
        "de": "Schlecht"
    },
    "Moderat": {
        "de": "Moderat"
    },
    "Good": {
        "de": "Gut"
    },
    "Very good": {
        "de": "Sehr gut"
    },
    "Show info": {
        "de": "Infos anzeigen"
    },
    "Hide info": {
        "de": "Infos verstecken"
    },
    "Video bitrate": {
        "de": "Video Bitrate"
    },
    "Video framerate": {
        "de": "Video FPS"
    },
    "Video jitter": {
        "de": "Video Jitter"
    },
    "Video packets lost": {
        "de": "Video Paketverlust"
    },
    "Video resolution": {
        "de": "Video Auflösung"
    },
    "bps": {
        "de": "bit/s"
    },
    "kbps": {
        "de": "kbit/s"
    },
    "Mbps": {
        "de": "Mbit/s"
    },
    "Gbps": {
        "de": "Gbit/s"
    },
    "Picture Guide": {
        "de": "Foto Leitfaden"
    },
    "Uploaded Pictures": {
        "de": "Hochgeladene Fotos"
    },
    "Uploaded": {
        "de": "Hochgeladen"
    },
    "Optional": {
        "de": "Optional"
    },
    "Required": {
        "de": "Erforderlich"
    },
    "Unassigned": {
        "de": "Keine Zuordnung"
    }
}

exports._ = function getLocalizedString(string) {
    if (currentLang === defaultLang || !strings.hasOwnProperty(string)) {
        return string;
    }

    let stringDict = strings[string];

    if (!stringDict.hasOwnProperty(currentLang)) {
        return string;
    }

    return stringDict[currentLang];
}

exports.setLanguage = function setLanguage(lang_code) {
    currentLang = lang_code;
}